<script>
import Layout from "@layouts/form";
import Feriado from "@forms/Feriado";

export default {
  page: {
    title: "Detalhes | Feriado"
  },
  components: { Layout, Feriado },
  props: {
    editable: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      title: "Feriado",
      items: [
        {
          text: "Cadastros",
          href: "/Cadastros"
        },
        {
          text: "Feriado",
          href: "/Feriado"
        },
        {
          text: "Edição",
          active: true
        }
      ]
    };
  }
};
</script>

<template>
  <Layout :title="title" :items="items">
    <div class="page-content">
      <Feriado :editable="editable"></Feriado>
    </div>
  </Layout>
</template>
